import { openBlock as o, createElementBlock as t, createElementVNode as r } from "vue";
import { _ as n } from "./_plugin-vue_export-helper-dad06003.js";
const s = {}, c = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function i(l, e) {
  return o(), t("svg", c, e[0] || (e[0] = [
    r("path", {
      d: "M8.03566 12.991L10.9185 15.9642C12.2759 12.0665 13.4049 10.3571 15.9642 8.03566M11.9999 21.9107C18.3428 21.9107 21.9107 18.3428 21.9107 11.9999C21.9107 5.65709 18.3428 2.08923 11.9999 2.08923C5.65709 2.08923 2.08923 5.65709 2.08923 11.9999C2.08923 18.3428 5.65709 21.9107 11.9999 21.9107Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const _ = /* @__PURE__ */ n(s, [["render", i]]);
export {
  _ as C
};
